"use client";

import { c as _c } from "react/compiler-runtime";
import { useActiveSessionId } from "@sukha/query";
import { useChromeExtensionLiveness } from "@/hooks/useChromeExtensionLiveness";
import { isConfirmedSessionId } from "@/lib/utils/sessionIds";

/**
 * Side-effect-only component that keeps the desktop (Chrome extension) badge
 * honest: while a session is active it pings the extension directly and reports
 * liveness to the shared connection-status store, so a live extension never
 * gets shown as "Off" due to throttled background polling or slipped heartbeats.
 *
 * Mount once near the app root (inside `ConnectionStatusProvider`).
 */
export function ChromeExtensionLivenessReporter() {
  const $ = _c(2);
  const activeSessionId = useActiveSessionId();
  const t0 = activeSessionId ?? undefined;
  let t1;
  if ($[0] !== t0) {
    t1 = isConfirmedSessionId(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSessionActive = t1;
  useChromeExtensionLiveness(isSessionActive);
  return null;
}